import { FaFileImage, FaFilePdf, FaImage } from "react-icons/fa";
import { fetchController } from "./FetchController/fetchController";
import { TbWorldWww } from "react-icons/tb";
import { MdOutlineTextSnippet } from "react-icons/md";

export const extractCustomFieldKeywords = (text) => {
  const regex = /\{{(.*?)\}}/g;
  let matches = [];
  let match;
  while ((match = regex.exec(text)) !== null) {
    matches.push(match[1]);
  }
  return matches;
};

export const addIntentsToAssistant = async (
  getAssistantData,
  defaultIntents,
  emails
) => {
  const url = getHostDomain();

  const assistantId = getAssistantData.data.id;

  const promises = defaultIntents.map(async (intent) => {
    const matchingEmail = emails.find((email) => email.name === intent.name);

    if (matchingEmail) {
      const endpoint = `/api/v1/assistant/${assistantId}/add_intent/${intent.id}`;
      const urlHit = url + endpoint;
      const body = {
        actions: [
          {
            type: "email",
            email: matchingEmail.email,
            emailName: matchingEmail.name.toUpperCase(),
          },
        ],
      };

      try {
        const getData = await fetchController(urlHit, "POST", body);
        return getData;
      } catch (error) {
        throw error;
      }
    } else {
      console.warn(`Email not found for intent: ${intent.name}`);
    }
  });

  try {
    const results = await Promise.all(promises);
    return results;
  } catch (error) {
    console.error("Error in one or more API requests:", error);
    throw error;
  }
};
export const isValidURL = (url) => {
  const regex =
    /^(?:(?:(?:https?|ftp):)?\/\/)?(?:www\.)?(localhost|(?:[^\s.]+[.](?:[a-z]{2,}|co\.uk|org\.in)))(?::\d+)?(?:[/?]\S*)?$/i;

  return regex.test(url);
};

export const clipText = (text, length = 20) => {
  if (text.length > length) {
    const slicedText = text.slice(0, length);
    return `${slicedText} ...`;
  }

  return text;
};

export const agencyBillingPlanGroupENUM = Object.freeze({
  regular: "Regular",
  addons: "Addon",
  hidden: "Hidden",
  wallet:"Wallet"
});

export const getHostDomain = () => {
  let apiUrl = `https://${localStorage.getItem("API_SERVER_URL")}`;
  if (!apiUrl) {
    window.location.href = "/login";
  }
  return apiUrl;
};

export const validateRegex = (pattern, inputValue) => {
  const regex = new RegExp(pattern);
  return regex.test(inputValue);
};

export const getAbsLogoUrl = (logo) => {
  if (!logo) return null;
  if (logo.includes(window.origin) || logo.includes("insighto")) return logo;
  return `${window.location.origin}${logo}`;
};

export const toBoolean = (value) => {
  if (value === true || value === 1 || value === "true") {
    return true;
  }
  const numberValue = Number(value);
  return !isNaN(numberValue) && numberValue > 0;
};

export const isValidDomain = (domain) =>
  /^(https?:\/\/)?(localhost|app\.insighto\.ai|staging\.app\.insighto\.ai)(:\d+)?(\/.*)?$/i.test(
    domain
  );

export const getCookieValue = (cookieName) => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (name === cookieName) {
      return value;
    }
  }
  return null;
};

const ghlLogo =
  "https://images.saasworthy.com/tr:w-160,h-0,c-at_max,e-sharpen-1/highlevel_29566_logo_1712921952_nwbzw.png";
export const DS_ICONS = {
  pdf: { icon: <FaFilePdf color="red" />, label: "PDF" },
  http: { icon: <TbWorldWww color="blue" />, label: "Website" },
  image: { icon: <FaImage color="blue" />, label: "Image" },
  text_blob: { icon: <MdOutlineTextSnippet color="blue" />, label: "Text" },
  text_image: { icon: <FaFileImage color="blue" />, label: "Text & Image" },
};
export const providers = {
  phone: {
    label: "Twilio",
    icon: <img src="/icons/twilio.svg" width={25} alt="Twilio" />,
  },
  sms: {
    label: "SMS",
    icon: <img src="/icons/twilio.svg" width={25} alt="SMS" />,
  },
  whatsapp: {
    label: "WhatsApp",
    icon: <img src="/icons/whatsapp.svg" width={25} alt="WhatsApp" />,
  },
  leadconnector: {
    label: "GHL Connect",
    icon: <img src={ghlLogo} width={25} alt="GHL Connect" />,
  },
  leadconnector_call: {
    label: "GHL Connect",
    icon: <img src={ghlLogo} width={25} alt="GHL Connect Call" />,
  },
  instagram: {
    label: "Instagram",
    icon: <img src="/icons/instagram.svg" width={25} alt="Instagram" />,
  },
  plivo_call: {
    label: "Plivo Call",
    icon: <img src="/icons/plivo.svg" width={25} alt="Plivo Call" />,
  },
  telnyx_call: {
    label: "Telnyx Call",
    icon: <img src="/icons/telnyx.svg" width={25} alt="Telnyx Call" />,
  },
    sip: {
    label: "Sip",
    icon: <img src="/icons/sip.svg" width={25} alt="sip" />,
  },
  telegram: {
    label: "Telegram",
    icon: (
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Telegram_2019_Logo.svg/2048px-Telegram_2019_Logo.svg.png"
        width={25}
        alt="Telegram"
      />
    ),
  },
  fb_messenger: {
    label: "Facebook Messenger",
    icon: (
      <img
        src="https://cdn4.iconfinder.com/data/icons/social-media-2285/1024/logo-512.png"
        width={25}
        alt="Facebook Messenger"
      />
    ),
  },
  ...DS_ICONS,
};

export const formatName = (name) => {
  return name.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getTagsData = (tags) => {
  try {
    return JSON.parse(tags);
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const loadGTM = (gtmId = "GTM-KVHCJWFD") => {
  if (document.getElementById("gtm-script")) return;

  const script = document.createElement("script");
  script.id = "gtm-script";
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
      j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
  document.head.appendChild(script);

  const noscript = document.createElement("noscript");
  noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;
  document.body.insertBefore(noscript, document.body.firstChild);
};

export const loadGAtag = (gaId = "G-BJJL0C4R0Y") => {
  if (document.getElementById("gtag-script")) return;

  const gaScript = document.createElement("script");
  gaScript.id = "gtag-script";
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  gaScript.async = true;
  document.head.appendChild(gaScript);

  const inlineGAScript = document.createElement("script");
  inlineGAScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}');
    `;
  document.head.appendChild(inlineGAScript);
};

